import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLoadDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" d="M11 4v3H5v2h6v3h1l4-4-4-4z" />
    <path fill="#616061" d="M0 1v14h8v-2H2V3h6V1z" />
  </svg>
);
export default SvgLoadDown;
